import { useEffect } from "react";
import Hero from "../components/Hero";
import SignatureSlider from "../components/SignatureSlider";
import MediterraneanKitchen from "../components/MediterraneanKitchen";
import WhyDetour from "../components/WhyDetour";
import CustomerExperience from "../components/CustomerExperience";
import WorkFriendly from "../components/WorkFriendly";
import Gallery from "../components/Gallery";
import MenuPreview from "../components/MenuPreview";
import Catering from "../components/Catering";
import ContactForm from "../components/ContactForm";
import Testimonials from "../components/Testimonials";
import InstagramFeed from "../components/InstagramFeed";
import VisitUs from "../components/VisitUs";
import { scrollToHash } from "../lib/scroll";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) scrollToHash(window.location.hash);
  }, []);

  return (
    <main>
      <Hero />
      <SignatureSlider />
      <MediterraneanKitchen />
      <WhyDetour />
      <CustomerExperience />
      <WorkFriendly />
      <Gallery />
      <MenuPreview />
      <Catering />
      <ContactForm />
      <Testimonials />
      <InstagramFeed />
      <VisitUs />
    </main>
  );
};

export default Home;
